import Vue from 'vue';
import VueRouter from 'vue-router';
import PageNotFound from './PageNotFound.vue';
import MAIN_COMPONENT_TANIEC_Z_GWIAZDAMI from '@/projects/taniec-z-gwiazdami/Main.vue';
import ROUTE_CHILDREN_TANIEC_Z_GWIAZDAMI from '@/projects/taniec-z-gwiazdami/routes';
import MAIN_COMPONENT_TYLKO_JEDEN from '@/projects/tylko-jeden/Main.vue';
import ROUTE_CHILDREN_TYLKO_JEDEN from '@/projects/tylko-jeden/routes';
import MAIN_COMPONENT_NINJA_WARRIOR from '@/projects/ninja-warrior/Main.vue';
import ROUTE_CHILDREN_NINJA_WARRIOR from '@/projects/ninja-warrior/routes';
import MAIN_COMPONENT_LOVE_ISLAND from '@/projects/love-island/Main.vue';
import ROUTE_CHILDREN_LOVE_ISLAND from '@/projects/love-island/routes';
import MAIN_COMPONENT_LEPSZA_POLSKA from '@/projects/lepsza-polska/Main.vue';
import ROUTE_CHILDREN_LEPSZA_POLSKA from '@/projects/lepsza-polska/routes';
import MAIN_COMPONENT_MUST_BE_THE_MUSIC from '@/projects/must-be-the-music/Main.vue';
import ROUTE_CHILDREN_MUST_BE_THE_MUSIC from '@/projects/must-be-the-music/routes';

Vue.use(VueRouter);

const routes = [
    {
        path: '/taniec-z-gwiazdami/',
        component: MAIN_COMPONENT_TANIEC_Z_GWIAZDAMI,
        children: ROUTE_CHILDREN_TANIEC_Z_GWIAZDAMI,
    },
    {
        path: '/tylko-jeden/',
        component: MAIN_COMPONENT_TYLKO_JEDEN,
        children: ROUTE_CHILDREN_TYLKO_JEDEN,
    },
    {
        path: '/ninja-warrior/',
        component: MAIN_COMPONENT_NINJA_WARRIOR,
        children: ROUTE_CHILDREN_NINJA_WARRIOR,
    },
    {
        path: '/love-island/',
        component: MAIN_COMPONENT_LOVE_ISLAND,
        children: ROUTE_CHILDREN_LOVE_ISLAND,
    },
    {
        // TODO: żeby zmienić urla `czysta-polska` (używanego produkcyjnie) na `lepsza-polska`
        // to najpierw powinien się zmienić url w mailingach na `lepsza-polska`
        // w przeciwnym razie link z maila będzie kierował na 404
        path: '/czysta-polska/',
        component: MAIN_COMPONENT_LEPSZA_POLSKA,
        children: ROUTE_CHILDREN_LEPSZA_POLSKA,
    },
    {
        path: '/must-be-the-music/',
        component: MAIN_COMPONENT_MUST_BE_THE_MUSIC,
        children: ROUTE_CHILDREN_MUST_BE_THE_MUSIC,
    },
    {
        path: '*',
        component: PageNotFound,
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = (to.meta && to.meta.title) || '';
    next();
});

export default router;
